import React from "react"
import WufooForm from 'react-wufoo-embed'

const WufooFormBlock = ({ formHash }) => {
  return (
    <div className={`pt-12 mb-12 mx-auto max-w-2xl`}>
        <WufooForm userName="diggspet" formHash={formHash} />
    </div>
  )
}

export default WufooFormBlock
